import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import Keycloak from 'keycloak-js';

import { KeycloakProfileCustom } from '../../models/KeycloakProfileCustom';


@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-header',
  imports: [MatMenuModule, MatIconModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  public isLoggedIn = false;
  public userProfile: KeycloakProfileCustom | null = null;
  userProfileTokenCompanyId: number;

  private readonly keycloak = inject(Keycloak);

  public ngOnInit(): void {
    this.isLoggedIn = this.keycloak.authenticated || false;

    if (this.isLoggedIn) {
      this.keycloak.loadUserProfile().then(profile => {
        this.userProfile = profile;
        if (this.userProfile.attributes === undefined) {
          const token = this.keycloak.token;
          if (token) {
            try {
              const tokenPayload = JSON.parse(atob(token.split('.')[1]));
              this.userProfileTokenCompanyId = tokenPayload.organization[0]["data-automation"].company_id[0];
            } catch (error) {
              console.error('userProfileTokenCompanyId error message', error);
            }
          }
        }
      });
    }
  }

  public login() {
    this.keycloak.login();
  }

  public logout() {
    this.keycloak.logout();
  }
}
